import { render, staticRenderFns } from "./DeliveryChallanItems.vue?vue&type=template&id=16b9750a&scoped=true&"
import script from "./DeliveryChallanItems.vue?vue&type=script&lang=js&"
export * from "./DeliveryChallanItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b9750a",
  null
  
)

export default component.exports